import { CARD_TYPE } from 'consts/enum';
import './card.scss';

export const CardTemplate = (model) => {
	const { id, imageAlt, style = '', subtitle, type = CARD_TYPE.SMALL, image, title, ellipsis = {} } = model || {};

	const isActive = id === 0;
	const isNext = id === 1;

	const generateEllipsis = (tag) => (ellipsis?.[tag] ? `${tag}-ellipsis-${ellipsis[tag]}` : '');
	/* html */
	const titleTag = title ? `<span class="title ${generateEllipsis('title')}" dir="auto">${title}</span>` : '';

	/* html */
	const descriptionTag = subtitle
		? `<span class="description ${generateEllipsis('description')}" dir="auto">
				${subtitle.replaceAll('\n', '<br/>')}
			</span>`
		: '';

	/* html */
	const imgTag = image ? `<img src="${image}" alt="${imageAlt}" loader="lazy" />` : '';

	/* html */
	const html = `
		<div class="engt-card engt-card-${type}" id="${id}" data-active="${isActive}" data-next="${isNext}"
		  ${style ? `style="${style}"` : ''} dir="auto">
			<div class="engt-card-clickable">
				${imgTag}
				<div class="engt-card-info" style="${imgTag ? '' : 'width: 100%'}">
					${titleTag}
					${descriptionTag}
				</div>
			</div>
			<div class="engt-card-dropdowns">
				<dropdowns></dropdowns>
			</div>
			<div class="engt-card-btns">
				<buttons></buttons>
			</div>
		</div>
    `;

	return html;
};
